<app-dave-list-card
    Headline="Lageränderungen"
    EmptyText="Keine Lageränderungen vorhanden"
    [Data]="MaterialToMaterialTableData$ | async"
    [DisplayedCollums]="['Amount', 'Type', 'Date']"
    [TableHeaderCollumsMap]="{
        Amount: 'Menge',
        Date: 'Datum',
        Type: 'Typ'
    }"
    [Clickable]="false"
    (EntryClicked$)="onOpenWarehouseMovement($event.entry.WarehouseMovementId)"
    style="max-height: 50vh"
    [IsLoading]="MaterialToMaterialTableDataLoading$ | async"
>
<!--    <button app-round-button headerButton onlyExpanded (click)="onAddWarehouseMovement()">-->
<!--        <fa-icon [icon]="'plus'"></fa-icon>-->
<!--    </button>-->
</app-dave-list-card>

